<template>
  <v-row style="padding-top:12px">
    <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Advising Meeting Slots</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="helpDialog" width="600">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon>fal fa-question-circle</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Advising Meeting Slots</v-card-title>
              <v-card-text>
                <p>This is where you can block out days and times to meet with students. Students who have selected the given major will be able to block out a 15-minute period in which to meet with you during this time. You can set up as many advising windows as you want, and each one can be individually set with its own major (if you advise for multiple majors you can set aside a block of time to just do one or another, or you can choose all of them for every window). Click the [+] button at the top of the list of Advising Windows or Add Window button at the bottom to add a new date and time availability to the system.</p>
                <p>When a student blocks out the time, it will be added to both your Google Calendar and to theirs (through their Covenant account). You and the student will also receive an email with details about the requested meeting. The calendar event will include a link to Google Meet, but you do not have to use that; you can communicate with the student via the sent email to establish a different means of communication if that is preferred.</p>
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="helpDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-row style="margin-top:-6px">
          <v-col cols="12" md="4">
            <v-card>
              <v-toolbar elevation="1">
                <v-toolbar-title>Advising Windows</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="success" icon @click="newWindowDialog = true">
                      <v-icon>fal fa-plus-square</v-icon>
                    </v-btn>
                  </template>
                  <span>Add new advising window</span>
                </v-tooltip>
              </v-toolbar>
              <v-list v-if="dates.length > 0" elevation="2">
                <v-list-item v-for="(item, index) in dates" :key="'date-' + index" @click="select(item._id)">
                  <v-list-item-content>
                    <v-list-item-title>{{ stringFormatDate(item.start) }}</v-list-item-title>
                    <v-list-item-subtitle>Slots taken: {{ item.slots.length - item.slotsAvailable }} / {{ item.slots.length }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-card-text v-else>
                There are currently no advising windows set up.
              </v-card-text>
              <v-card-actions>
                <v-dialog v-model="newWindowDialog" width="300">
                  <template v-slot:activator="{ on: dialogOn }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on: tooltipOn }">
                        <v-btn v-on="{ ...dialogOn, ...tooltipOn }" color="success" outlined>
                          <v-icon left small>fas fa-plus-circle</v-icon>
                          Add Window
                        </v-btn>
                      </template>
                      <span>Add new advising window</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title>Add Advising Window</v-card-title>
                    <v-card-text>
                      <v-autocomplete v-model="majors" :items="majorList" label="Major(s) to Advise" outlined multiple chips deletable-chips small-chips>
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="majors.length <= 3 && index <= 2" small close @click:close="majors.splice(index, 1)">
                            <span>{{ item.text }}</span>
                          </v-chip>
                          <span v-if="majors.length === majorList.length && index === 0" class="grey--text caption">All {{ majors.length }} Majors Selected</span>
                          <span v-else-if="majors.length > 3 && index === 0" class="grey--text caption">
                            {{ majors.length }} Majors Selected
                          </span>
                        </template>
                        <template v-slot:prepend-item>
                          <v-list-item ripple @click="selectAllMajors">
                            <v-list-item-action>
                              <v-icon :color="majors.length > 0 ? 'primary' : ''">
                                {{ majors.length === 0 ? 'far fa-square' : (majors.length === majorList.length ? 'fas fa-check-square' : 'fas fa-minus-square') }}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ majors.length === majorList.length ? 'Deselect All' : 'Select All' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                      <date-picker v-model="newDate" label="Date"></date-picker>
                      <v-autocomplete v-model="newStart" :items="startTimeOptions" label="Start Time" outlined></v-autocomplete>
                      <v-text-field v-model="newDuration" label="Duration of slots" type="number" min="5" max="60" step="5" hint="Minutes for each slot" outlined></v-text-field>
                      <v-autocomplete v-model="newEnd" :items="endTimeOptions" label="End Time" outlined></v-autocomplete>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="success" text @click="addWindow">Add Window</v-btn>
                      <v-btn text @click="newWindowDialog = false">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="8">
            <v-card v-if="selectedId">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ stringFormatDate(selectedStart).replace(' at ', ' from ') }} - {{ stringFormatDate(selectedEnd).substr(21) }}</v-list-item-title>
                    <v-list-item-subtitle>Advising Window Date and Time</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon @click="removeAdvisingWindow">
                          <v-icon color="error">fal fa-times-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Remove advising window</span>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ getMajorDesc(selectedMajors) }}</v-list-item-title>
                    <v-list-item-subtitle>Major{{ selectedMajors.length !== 1 ? 's' : ''}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-dialog v-model="editMajorDialog" width="400">
                      <template v-slot:activator="{ on: dialogOn }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on: tooltipOn }">
                            <v-btn v-on="{ ...dialogOn, ...tooltipOn }" icon>
                              <v-icon color="info">fal fa-edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit Major(s) in this advising window</span>
                        </v-tooltip>
                      </template>
                      <v-card>
                        <v-card-title>Edit Majors</v-card-title>
                        <v-card-text>
                          <v-autocomplete v-model="majors" :items="majorList" label="Major(s) to Advise" outlined multiple chips deletable-chips small-chips>
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="majors.length <= 3 && index <= 2" small close @click:close="majors.splice(index, 1)">
                                <span>{{ item.text }}</span>
                              </v-chip>
                              <span v-if="majors.length === majorList.length && index === 0" class="grey--text caption">All {{ majors.length }} Majors Selected</span>
                              <span v-else-if="majors.length > 3 && index === 0" class="grey--text caption">
                                {{ majors.length }} Majors Selected
                              </span>
                            </template>
                            <template v-slot:prepend-item>
                              <v-list-item ripple @click="selectAllMajors">
                                <v-list-item-action>
                                  <v-icon :color="majors.length > 0 ? 'primary' : ''">
                                    {{ majors.length === 0 ? 'far fa-square' : (majors.length === majorList.length ? 'fas fa-check-square' : 'fas fa-minus-square') }}
                                  </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ majors.length === majorList.length ? 'Deselect All' : 'Select All' }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                          </v-autocomplete>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text @click="editMajorDialog = false">Cancel</v-btn>
                          <v-btn :disabled="selectedMajors.join(',') === majors.join(',')" text color="success" @click="updateMajors">Save Changes</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ selectedSlotsAvailable }} slots available</v-list-item-title>
                    <v-list-item-subtitle>{{ selectedSlots.length }} total slots</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-dialog v-model="timeEdit" width="400">
                      <template v-slot:activator="{ on: dialogOn }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on: tooltipOn }">
                            <v-btn v-on="{ ...dialogOn, ...tooltipOn }" icon>
                              <v-icon color="info">fal fa-edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit Start/End Times</span>
                        </v-tooltip>
                      </template>
                      <v-card>
                        <v-card-title>Edit Start/Edit Times</v-card-title>
                        <v-card-text>
                          <v-autocomplete v-model="editStart" :items="editStartTimeOptions" label="Start Time" outlined></v-autocomplete>
                          <v-autocomplete v-model="editEnd" :items="editEndTimeOptions" label="End Time" outlined></v-autocomplete>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text @click="timeEdit = false">Cancel</v-btn>
                          <v-btn :disabled="parseInt(editStart.replace(':','')) === parseInt(new Date(selectedStart).toLocaleTimeString().replace(':', '')) && parseInt(editEnd.replace(':','')) === parseInt(new Date(selectedEnd).toLocaleTimeString().replace(':',''))" text color="success" @click="saveTimeEdit">Save Changes</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-divider style="border-width:3px"></v-divider>
              <v-list>
                <v-list-item v-for="({ time, student }, index) in selectedSlots" :key="'time-' + index">
                  <template v-if="student">
                    <v-list-item-content style="cursor:pointer" @click="$router.push('/admin/advising/student/' + student.id)">
                      <v-list-item-title>{{ student.name }}</v-list-item-title>
                      <v-list-item-subtitle>{{ time }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-subtitle>Major: {{ student && 'academics' in student && 'major' in student.academics ? getMajorDesc(student.academics.major) : '--Unspecified--' }}</v-list-item-subtitle>
                      <v-list-item-subtitle>Pre-registered? {{ student && 'academics' in student && 'preReg' in student.academics && student.academics.preReg ? 'Y' : 'N' }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-tooltip v-if="'email' in student" top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon target="_blank" :href="'mailto:' + student.email">
                            <v-icon>fal fa-envelope</v-icon>
                          </v-btn>
                        </template>
                        <span>Send an email to this student</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>--Unclaimed Slot--</v-list-item-title>
                      <v-list-item-subtitle>{{ time }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon @click="removeTimeSlot(index)">
                            <v-icon color="red">fal fa-times-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove this time slot</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </v-list>
            </v-card>
            <v-card v-else-if="dates.length > 0">
              <v-card-text>Select a date window on the left to view the details of the registration slots within.</v-card-text>
            </v-card>
            <v-card v-else>
              <v-card-text>You currently do not have any advising windows set up for future dates. Click the [+] or [+ Add Window] buttons on the left to add new advising windows.</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-dialog v-model="messageWindow" persistent width="600">
      <v-card v-if="isSending">
        <v-card-title>Sending Message to student{{ messageRecipients.length > 1 ? 's' : '' }}</v-card-title>
        <v-card-text>Sent {{ messagesSent }} out of {{ messageRecipients.length }}</v-card-text>
        <v-card-text>
          <v-alert v-if="sendComplete" type="info">Sending is complete.</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!sendComplete" text @click="closeMessageWindow">Close</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title>Message to student{{ messageRecipients.length > 1 ? 's' : '' }}</v-card-title>
        <v-card-text>
          <p>Please enter the message to send to the student{{ messageRecipients.length > 1 ? 's' : '' }} whose appointment slots were removed. This will be sent to them as an email from the system and removed from their Calendar.</p>
          <v-text-field v-model="messageSubject" label="Subject" outlined></v-text-field>
          <h5>Email Message</h5>
          <html-editor v-model="message"></html-editor>
        </v-card-text>
        <v-card-text>
          <v-checkbox v-model="messageIncludeDateTime" label="Include date and time of canceled slot in the email after this message text"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" text @click="sendMessages">Send Messages</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { ref, computed, onMounted, onBeforeUnmount, watch } from '@vue/composition-api'
import { stringFormatDate } from '../../../helpers/formatters'

export default {
  components: {
    DatePicker: () => import('@/components/forms/inputs/DatePicker'),
    HtmlEditor: () => import('@/components/forms/HTMLEditor')
  },
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user)
    const term = computed(() => root.$store.state.admin.term)
    const dates = ref([])
    const isLoaded = ref(false)

    const service = root.$feathers.service('orientation/advisor')

    const selectedId = ref(null)
    const selectedStart = ref(null)
    const selectedEnd = ref(null)
    const selectedMajors = ref([])
    const selectedSlots = ref([])
    const selectedSlotsAvailable = ref(null)
    function select (id) {
      selectedId.value = id
      root.$store.commit('admin/setAdvisingSelection', id)
      service.get(selectedId.value).then(({ start, end, majors, slots, slotsAvailable }) => {
        selectedStart.value = start
        selectedEnd.value = end
        selectedMajors.value = majors
        selectedSlots.value = slots
        selectedSlotsAvailable.value = slotsAvailable
      })
    }

    const onPatchedListener = (data) => {
      if (isLoaded.value && term.value === data.term && user.value.pidm === data.pidm) {
        let exists = false
        for (let i = 0; i < dates.value.length; i++) {
          if (dates.value[i]._id === data._id) {
            exists = true
            dates.value.splice(i, 1, data)
            if (selectedId.value === data._id) {
              select(data._id)
            }
          }
        }
        if (!exists) {
          dates.value.push(data)
        }
      }
    }
    const onRemovedListener = (data) => {
      for (let i = 0; i < dates.value.length; i++) {
        if (dates.value[i]._id === data._id) {
          dates.value.splice(i, 1)
        }
      }
    }
    onMounted(() => {
      if (!root.$store.getters.hasRole('Employee')) {
        root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have access to the admin system.' })
        root.$router.push('/')
        return
      }
      isLoaded.value = true
      service.on('patched', onPatchedListener)
      service.on('removed', onRemovedListener)
      root.$feathers.service('forms/select-options').find({ query: { name: 'Major Code' } }).then(({ data }) => {
        if (data.length > 0) {
          root.$feathers.service('forms/select-options').get(data[0].value).then((data) => {
            majorList.value = data.options
          })
        }
      })
      if (term.value !== '') {
        loadDates()
      }
    })
    onBeforeUnmount(() => {
      service.removeListener('patched', onPatchedListener)
      service.removeListener('removed', onRemovedListener)
    })

    async function loadDates () {
      if (isLoaded.value) {
        isLoaded.value = false
        dates.value = []
        let query = { pidm: user.value.pidm, term: term.value, end: { $gt: new Date() }, $limit: 0, $sort: { start: 1 } }
        let { total } = await service.find({ query })
        query.$limit = 20
        for (let i = 0; i < total; i += 20) {
          query.$skip = i
          let { data } = await service.find({ query })
          for (const obj of data) {
            dates.value.push(obj)
          }
        }
        isLoaded.value = true
        if (root.$store.state.admin.advisingSelection !== '') {
          select(root.$store.state.admin.advisingSelection)
        }
      }
    }
    watch(term, () => loadDates())

    const majorList = ref([])
    const majors = ref([])
    function selectAllMajors () {
      if (majors.value.length < majorList.value.length) {
        majors.value = []
        for (const obj of majorList.value) majors.value.push(obj.value)
      } else {
        majors.value = []
      }
    }

    const newWindowDialog = ref(false)
    const newDate = ref('')
    const newStart = ref('')
    const newDuration = ref(15)
    const newEnd = ref('')
    const startTimeOptions = computed(() => {
      let start = new Date()
      start.setHours(6)
      start.setMinutes(0)
      let end = new Date()
      if (newEnd.value) {
        let [hour, temp] = newEnd.value.split(':')
        let [min, ampm] = temp.split(' ')
        if (ampm === 'PM' && hour < 12) hour += 12
        end.setHours(hour)
        end.setMinutes(min)
      } else {
        end.setHours(21)
        end.setMinutes(0)
      }
      if (end < start) end.setDate(end.getDate() + 1)
      let arr = []
      while (start.toISOString() < end.toISOString()) {
        let temp = start.toLocaleTimeString().split(':')
        let time = temp[0] + ':' + temp[1] + ' ' + temp[2].substr(-2)
        arr.push(time)
        start.setMinutes(start.getMinutes() + 15)
      }
      return arr
    })
    const endTimeOptions = computed(() => {
      let start = new Date()
      if (newStart.value) {
        let [hour, temp] = newStart.value.split(':')
        hour = parseInt(hour)
        let [min, ampm] = temp.split(' ')
        min = parseInt(min) + newDuration.value
        if (ampm === 'PM' && hour < 12) hour += 12
        start.setHours(hour)
        start.setMinutes(min)
      } else {
        start.setHours(6)
        start.setMinutes(newDuration.value)
      }
      let end = new Date()
      end.setHours(21)
      end.setMinutes(0)
      if (end < start) end.setDate(end.getDate() + 1)
      let arr = []
      while (start.toISOString() <= end.toISOString()) {
        let temp = start.toLocaleTimeString().split(':')
        let time = temp[0] + ':' + temp[1] + ' ' + temp[2].substr(-2)
        arr.push(time)
        start.setMinutes(start.getMinutes() + newDuration.value)
      }
      return arr
    })

    function addWindow () {
      if (newDate.value !== '' && newStart !== '' && newDuration.value === '' && newEnd !== '') {
        let start = new Date(newDate.value + ' ' + newStart.value)
        let end = new Date(newDate.value + ' ' + newEnd.value)
        let slots = []
        for (let dt = new Date(start.toISOString()); dt.toISOString() < end.toISOString(); dt.setMinutes(dt.getMinutes() + newDuration.value)) {
          let temp = dt.toLocaleTimeString().split(':')
          let time = temp[0] + ':' + temp[1] + ' ' + temp[2].substr(-2)
          slots.push({ time })
        }
        let obj = {
          pidm: user.value.pidm,
          name: user.value.name,
          email: user.value.email,
          term: term.value,
          majors: majors.value,
          start,
          end,
          slotLength: newDuration.value,
          slotsAvailable: slots.length,
          slots
        }
        service.create(obj).then((data) => dates.value.push(data))
        newWindowDialog.value = false
      }
    }

    const helpDialog = ref(false)

    function getMajorDesc (majors) {
      if (majors.length === majorList.value.length) {
        return 'Advising open for all majors'
      }
      let arr = []
      for (let i = 0; i < majors.length; i++) {
        for (let j = 0; j < majorList.value.length; j++) {
          if (majorList.value[j].value === majors[i]) {
            arr.push(majorList.value[j].text)
            break
          }
        }
      }
      return arr.join('; ')
    }

    const editMajorDialog = ref(false)
    function updateMajors () {
      service.patch(selectedId.value, { majors: majors.value }).then((data) => {
        root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'Majors Updated Successfully' })
        editMajorDialog.value = false
      })
    }

    const timeEdit = ref(false)
    const editStart = ref('')
    const editEnd = ref('')
    const editStartTimeOptions = computed(() => {
      let start = new Date()
      start.setHours(6)
      start.setMinutes(0)
      let end = new Date()
      if (editEnd.value) {
        let [hour, temp] = editEnd.value.split(':')
        let [min, ampm] = temp.split(' ')
        if (ampm === 'PM' && hour < 12) hour = parseInt(hour) + 12
        end.setHours(hour)
        end.setMinutes(min)
      } else {
        end.setHours(21)
        end.setMinutes(0)
      }
      if (end < start) end.setDate(end.getDate() + 1)
      let arr = []
      while (start.toISOString() < end.toISOString()) {
        let temp = start.toLocaleTimeString().split(':')
        let time = temp[0] + ':' + temp[1] + ' ' + temp[2].substr(-2)
        arr.push(time)
        start.setMinutes(start.getMinutes() + 15)
      }
      return arr
    })
    const editEndTimeOptions = computed(() => {
      let start = new Date()
      if (editStart.value) {
        let [hour, temp] = editStart.value.split(':')
        let [min, ampm] = temp.split(' ')
        if (ampm === 'PM' && hour < 12) hour = parseInt(hour) + 12
        start.setHours(hour)
        start.setMinutes(min)
      } else {
        start.setHours(6)
        start.setMinutes(15)
      }
      let end = new Date()
      end.setHours(21)
      end.setMinutes(0)
      if (end < start) end.setDate(end.getDate() + 1)
      let arr = []
      while (start.toISOString() <= end.toISOString()) {
        let temp = start.toLocaleTimeString().split(':')
        let time = temp[0] + ':' + temp[1] + ' ' + temp[2].substr(-2)
        arr.push(time)
        start.setMinutes(start.getMinutes() + 15)
      }
      return arr
    })
    watch(timeEdit, (val) => {
      if (val) {
        let dt = new Date(selectedStart.value)
        let temp = dt.toLocaleTimeString().split(':')
        editStart.value = temp[0] + ':' + temp[1] + ' ' + temp[2].substr(-2)
        dt = new Date(selectedEnd.value)
        temp = dt.toLocaleTimeString().split(':')
        editEnd.value = temp[0] + ':' + temp[1] + ' ' + temp[2].substr(-2)
      }
    })
    function saveTimeEdit () {
      messageRecipients.value = []
      let newStart = parseInt(editStart.value.replace(':', '')) + (editStart.value.substr(-2) === 'PM' && editStart.value.substr(0, 2) !== '12' ? 1200 : 0)
      let newEnd = parseInt(editEnd.value.replace(':', '')) + (editEnd.value.substr(-2) === 'PM' && editEnd.value.substr(0, 2) !== '12' ? 1200 : 0)
      for (let i = 0; i < selectedSlots.value.length; i++) {
        let { time, student } = selectedSlots.value[i]
        if (student == null) continue
        if (parseInt(time.replace(':', '')) + (time.substr(-2) === 'PM' && time.substr(0, 2) !== '12' ? 1200 : 0) < newStart) {
          messageRecipients.value.push({ ...student, time })
        } else if (newEnd < parseInt(time.replace(':', '')) + (time.substr(-2) === 'PM' && time.substr(0, 2) !== '12' ? 1200 : 0)) {
          messageRecipients.value.push({ ...student, time })
        }
      }
      let start = new Date(selectedStart.value)
      let [startHour, startTemp] = editStart.value.split(':')
      let [startMin, startAmPm] = startTemp.split(' ')
      if (startAmPm === 'PM' && startHour !== '12') startHour = parseInt(startHour) + 12
      start.setHours(startHour)
      start.setMinutes(startMin)
      let end = new Date(selectedStart.value)
      let [endHour, endTemp] = editEnd.value.split(':')
      let [endMin, endAmPm] = endTemp.split(' ')
      if (endAmPm === 'PM' && endHour !== '12') endHour = parseInt(endHour) + 12
      end.setHours(endHour)
      end.setMinutes(endMin)
      let slots = []
      let slotsAvailable = 0
      let windowStart = parseInt(editStart.value.replace(':', ''))
      if (editStart.value.substr(-2) === 'PM' && editStart.value.substr(0, 2) !== '12') windowStart += 1200
      let windowEnd = parseInt(editEnd.value.replace(':', ''))
      if (editEnd.value.substr(-2) === 'PM' && editEnd.value.substr(0, 2) !== '12') windowEnd += 1200
      let hash = {}
      for (let i = 0; i < selectedSlots.value.length; i++) {
        let index = parseInt(selectedSlots.value[i].time.replace(':', ''))
        hash[index] = selectedSlots.value[i]
      }
      for (let i = windowStart; i < windowEnd; i += (i % 100 === 45 ? 55 : 15)) {
        if (i in hash) {
          let obj = { time: hash[i].time }
          if ('student' in hash[i] && hash[i].student != null) {
            obj.student = hash[i].student.id
          } else {
            slotsAvailable++
          }
          slots.push(obj)
        } else {
          let hour = Math.floor(i / 100)
          let min = i % 100
          let ampm = (hour >= 12 ? 'PM' : 'AM')
          if (hour > 12) hour -= 12
          let time = hour + ':' + (min < 10 ? '0' : '') + min + ' ' + ampm
          slots.push({ time })
          slotsAvailable++
        }
      }
      let patch = { start, end, slots, slotsAvailable }
      if (messageRecipients.value.length > 0) {
        let len = messageRecipients.value.length
        let msg = 'There ' + (len === 1 ? 'is a student' : 'are ' + len + ' students') + ' who registered for a slot that is being removed. Do you still wish to continue? You will be prompted to enter a message to send to the student' + (len > 1 ? 's' : '') + ' to inform them that they will need to make a new appointment.'
        if (confirm(msg)) {
          service.patch(selectedId.value, patch).then(() => {
            timeEdit.value = false
            messageWindow.value = true
            root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'The advising window was updated successfully.' })
          })
        }
      } else {
        service.patch(selectedId.value, patch).then(() => {
          timeEdit.value = false
          root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'The advising window was updated successfully.' })
        })
      }
    }
    function removeAdvisingWindow () {
      messageRecipients.value = []
      for (let i = 0; i < selectedSlots.value.length; i++) {
        let { time, student } = selectedSlots.value[i]
        if (student == null) continue
        messageRecipients.value.push({ ...student, time })
      }
      if (messageRecipients.value.length > 0) {
        let len = messageRecipients.value.length
        let msg = 'There ' + (len === 1 ? 'is a student' : 'are ' + len + ' students') + ' who registered for a slot that is being removed. Do you still wish to continue? You will be prompted to enter a message to send to the student' + (len > 1 ? 's' : '') + ' to inform them that they will need to make a new appointment.'
        if (confirm(msg)) {
          service.remove(selectedId.value).then(() => {
            selectedId.value = null
            timeEdit.value = false
            root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'The advising window was removed successfully.' })
          })
          timeEdit.value = false
          messageWindow.value = true
        }
      } else {
        if (confirm('Are you sure you want to remove this advising window?')) {
          service.remove(selectedId.value).then(() => {
            selectedId.value = null
            timeEdit.value = false
            root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'The advising window was removed successfully.' })
          })
        }
      }
    }

    const messageWindow = ref(false)
    const messageSubject = ref('')
    const message = ref('')
    const messageIncludeDateTime = ref(false)
    const messageRecipients = ref([])
    const isSending = ref(false)
    const sendComplete = ref(false)
    const messagesSent = ref(0)
    async function sendMessages () {
      if (message.value !== '' && message.value !== '<p></p>' && messageSubject.value !== '') {
        sendComplete.value = false
        isSending.value = true
        for (const { email, time } of messageRecipients.value) {
          let html = message.value
          if (messageIncludeDateTime.value) {
            html += '<p>The canceled meeting was on ' + stringFormatDate(selectedStart.value).substr(0, 17) + ' at ' + time + '.</p>'
          }
          await root.$feathers.service('system/email').create({
            from: user.value.email,
            to: email,
            subject: messageSubject.value,
            html
          })
          messagesSent.value++
        }
        sendComplete.value = true
      } else {
        alert('You cannot send a message with an empty subject and empty email message. Please enter something into each of these places before sending the email.')
      }
    }
    function closeMessageWindow () {
      messageWindow.value = false
      isSending.value = false
      sendComplete.value = false
    }

    function removeTimeSlot (index) {
      let slots = []
      for (let i = 0; i < selectedSlots.value.length; i++) {
        if (i === index) continue
        let obj = { time: selectedSlots.value[i].time }
        if ('student' in selectedSlots.value[i] && selectedSlots.value[i].student != null) obj.student = selectedSlots.value[i].student.id
        slots.push(obj)
      }
      service.patch(selectedId.value, { slots }).then(() => {
        root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 6000, text: 'Time slot removed successfully' })
      })
    }

    return {
      user,
      term,
      dates,
      selectedId,
      selectedStart,
      selectedEnd,
      selectedMajors,
      selectedSlots,
      selectedSlotsAvailable,
      select,
      majorList,
      majors,
      selectAllMajors,
      newWindowDialog,
      newDate,
      newStart,
      newEnd,
      startTimeOptions,
      endTimeOptions,
      addWindow,
      helpDialog,
      getMajorDesc,
      editMajorDialog,
      updateMajors,
      timeEdit,
      editStart,
      editEnd,
      editStartTimeOptions,
      editEndTimeOptions,
      saveTimeEdit,
      removeAdvisingWindow,
      messageWindow,
      messageSubject,
      message,
      messageIncludeDateTime,
      messageRecipients,
      isSending,
      sendComplete,
      messagesSent,
      sendMessages,
      closeMessageWindow,
      removeTimeSlot,
      stringFormatDate
    }
  }
}
</script>
